import { PageHeaderProvider } from "@mcleod/common";
import { UserSettings } from "@mcleod/core";

export class PortalPageHeaderProvider extends PageHeaderProvider {
    public override shouldDisplayHelpLinks(): boolean {
        return UserSettings.isUserTypeCustomer() || UserSettings.isUserTypeCarrier()
            || UserSettings.isUserTypeLocation();
    }
}
